module.exports = __webpack_public_path__ + "img/Small-Horizontal-Rectangular-Attachment-36.ee297b52.png";